module.exports = __webpack_public_path__ + "img/web4icon1.f2039e13.png";